import { Handle, Position } from 'reactflow'
import React from 'react'
import { motion } from 'framer-motion'

const SourceNode = ({ data }: { data: { name: string } }) => {
  return (
    <motion.div className="shadow-md rounded-full bg-white border-stone-400 border-primary-xiketic border-2 px-5 py-3 text-primary-xiketic font-bold nodrag">
      <div>{data.name}</div>
      <Handle type="source" position={Position.Right} className="" />
    </motion.div>
  )
}

export default SourceNode
